//
// locales/vanilla/lv.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/lv.json';
import localeData from 'react-intl/locale-data/lv.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
